import engineApi from '@/plugins/engine-api.js'
import Vue from 'vue'

let vm = new Vue()

const getDefaultState = () => {
  return {
    fatal: false,
    user: null,
    accounts: null,
    account: null,
    channels: [],
    saveAccountId: null,
    embedMode: null
  }
}

const state = getDefaultState()

const getters = {
  fatal: state => state.fatal,
  currentUser: state => state.user,
  currentAccounts: state => state.accounts,
  currentAccount: state => state.account,
  currentAccountChannels: state => state.channels,
  currentSaveAccountId: state => state.saveAccountId,
  currentEmbedMode: state => state.embedMode
}

const actions = {
  fetchUser ({ commit }) {
    engineApi.fetchUser(function (err, user) {
      if (err) {
        if (process.env.NODE_ENV === 'development') console.log(err)
      } else {
        // set Google Analytics userId
        // if (process.env.NODE_ENV !== 'development') window.ga('set', 'userId', user['cognito_id'])
        commit('SET_FATAL', false)
        commit('SET_USER', user)
      }
    })
  },
  resetUser ({ commit }) {
    commit('SET_USER', { email: null })
  },
  fetchAccounts ({ dispatch, commit, state }) {
    engineApi.fetchAccounts(function (err, accounts) {
      if (err) {
        if (process.env.NODE_ENV === 'development') console.log(err)
        if (state.account) {
          dispatch('fetchChannels', state.account.id)
        }
      } else {
        commit('SET_FATAL', false)
        commit('SET_ACCOUNTS', accounts)
        if (accounts && accounts.length > 0) {
          var setId = accounts[0].id // default to first account in list
          if (state.account && accounts.find(x => x.id === state.account.id)) {
            setId = state.account.id
          }
          var lastId = vm.$cookie.get('lastAccountId') // fetch the last account cookie
          if (lastId) {
            lastId = parseInt(lastId)
            if (accounts.find(x => x.id === lastId)) { // lastId is in list of account
              setId = lastId
            }
          }
          // Always refresh account + channels. Skipping when persistedstate
          // already has an account left channels null and kicked users out.
          dispatch('setAccount', setId)
        } else if (!state.account) {
          commit('SET_FATAL', true)
        }
      }
    })
  },
  fetchChannels ({ commit }, accountId) {
    return new Promise((resolve, reject) => {
      engineApi.fetchChannels(accountId,
        function (err, channels) {
          if (err) {
            // Keep Dashboard mounted; a channels fetch failure is not a session expiry
            commit('SET_CHANNELS', [])
            resolve()
          } else {
            commit('SET_CHANNELS', channels)
            resolve()
          }
        }
      )
    })
  },
  setAccount ({ dispatch, commit }, accountId) {
    engineApi.fetchAccount(accountId, function (err, acc) {
      if (err) {
        if (process.env.NODE_ENV === 'development') console.log(err)
        dispatch('fetchChannels', accountId)
      } else if (acc) {
        commit('SET_ACCOUNT', acc)
        vm.$cookie.set('lastAccountId', accountId)
        dispatch('fetchChannels', accountId)
      }
    })
  },
  setSaveAccountId ({ commit }, accountId) {
    commit('SET_SAVE_ACCOUNT_ID', accountId)
  },
  setFatal ({ commit }, fatal) {
    commit('SET_FATAL', fatal)
  },
  resetUserState ({ commit }) {
    commit('RESET_USER_STATE')
  },
  setEmbedMode ({ commit }, embedMode) {
    commit('SET_EMBED_MODE', embedMode)
  }
}

const mutations = {
  SET_USER (state, data) {
    state.user = data
  },
  SET_ACCOUNTS (state, data) {
    state.accounts = data
  },
  SET_ACCOUNT (state, account) {
    state.account = account
  },
  SET_CHANNELS (state, data) {
    state.channels = data
  },
  SET_SAVE_ACCOUNT_ID (state, accountId) {
    state.saveAccountId = accountId
  },
  SET_FATAL (state, fatal) {
    state.fatal = fatal
  },
  SET_EMBED_MODE (state, embedMode) {
    state.embedMode = embedMode
  },
  RESET_USER_STATE (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
